module.exports = __webpack_public_path__ + "img/faq03.41d01ce0.svg";